import theme from '../constants/Colors';

const Text = props => {

    const selectWeight = weight => {
        switch (weight) {
            case 'extralight': 
                return 200
            case 'light': 
                return 300
            case 'medium': 
                return 500
            case 'semibold': 
                return 600
            case 'bold': 
                return 700
            case 'extrabold': 
                return 800
            case 'black': 
                return 900
            case 'weight': 
                return 1000
            default: 
                return 400
            
        }
    }
    
    return(
        <span
            onTransitionEnd={props.onTransitionEnd} onClick={props.onClick} style={{
            color: props.color ? props.color : theme.light.Audi, 
            fontWeight: selectWeight(props.weight), 
            fontSize: props.size ? props.size: 17,
            ...props.style}}>{props.children}</span>
    )
}

export default Text